import * as React from 'react';
import { GlobalStyles, Stack, styled } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import AppTheme from '../shared-theme/AppTheme';

const LoadingContainer = styled(Stack)(({ theme }) => ({
  height: 'calc((1 - var(--template-frame-height, 0)) * 100dvh)',
  minHeight: '100dvh',
  padding: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(4),
  },
  '&::before': {
    content: '""',
    display: 'block',
    position: 'absolute',
    zIndex: -1,
    inset: 0,
    backgroundImage:
      'radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))',
    backgroundRepeat: 'no-repeat',
    ...theme.applyStyles('dark', {
      backgroundImage:
        'radial-gradient(at 50% 50%, hsla(210, 100%, 16%, 0.5), hsl(220, 30%, 5%))',
    }),
  },
}));

export default function GradientCircularProgress(props: { disableCustomTheme?: boolean }) {
  return (
    <AppTheme {...props}>
      <LoadingContent />
    </AppTheme>
  );
}

function LoadingContent() {
  return (
    <LoadingContainer>
      <GlobalStyles
        styles={{
          body: {
            margin: 0,
            padding: 0,
            overflow: 'hidden',
            height: '100%'
          }
        }}
      />
      <svg width={0} height={0} style={{ margin: '0 auto' }}>
        <defs>
          <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#e01cd5" />
            <stop offset="100%" stopColor="#1CB5E0" />
          </linearGradient>
        </defs>
      </svg>
      <CircularProgress sx={{ 'svg circle': { stroke: 'url(#my_gradient)' }, width: '64px !important', height: '64px !important' }} />
    </LoadingContainer>
  )
}